import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class LogoutDetectionService {
  private checkInterval: any;
  private protectedRoutes = [
    '/user-profile',
    '/orders',
    '/wishlist',
    '/order-confirmation',
    '/order-status',
    '/proforma-status',
  ];

  constructor(
    private authService: AuthService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  initializeLogoutDetection(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    // Listen for storage changes (logout from other tabs)
    window.addEventListener('storage', (event) => {
      if (
        event.key === 'userData1' ||
        event.key === 'userCode' ||
        event.key === 'eol_user_code'
      ) {
        // Check if user data was removed (logout)
        if (!event.newValue) {
          setTimeout(() => {
            this.handleLogout();
          }, 100);
        }
      }
    });

    // Periodic check for logout state (every 10 seconds)
    this.checkInterval = setInterval(() => {
      this.checkLogoutState();
    }, 10000);
  }

  checkLogoutState(): void {
    if (!this.hasActiveSession()) {
      this.handleLogout();
    }
  }

  private hasActiveSession(): boolean {
    if (this.authService.isLoggedIn) {
      return true;
    }

    try {
      const userData = localStorage.getItem('userData1');
      if (userData) {
        try {
          return !!JSON.parse(userData)?.id;
        } catch {
          return userData.length > 0;
        }
      }
    } catch {
      return false;
    }

    return !!(
      localStorage.getItem('eol_user_code') || localStorage.getItem('userCode')
    );
  }

  private handleLogout(): void {
    this.authService.setLoggedInState(false, null);

    const currentRoute = this.router.url;
    const isProtectedRoute = this.protectedRoutes.some((route) =>
      currentRoute.includes(route),
    );

    if (isProtectedRoute) {
      this.router.navigate(['/home']);
    }
  }

  logoutWithRefresh(): void {
    localStorage.removeItem('userData1');
    localStorage.removeItem('userData');
    localStorage.removeItem('useractive');
    localStorage.removeItem('userCode');
    localStorage.removeItem('eol_user_code');
    localStorage.removeItem('eol_ref_token');
    localStorage.removeItem('eol_access_token');
    localStorage.removeItem('registrationPhoneNumber');
    localStorage.removeItem('registrationOtp');

    this.authService.setLoggedInState(false, null);
    this.router.navigate(['/home']);
  }

  destroy(): void {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
  }
}
